import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useActorBoundary } from '@application/common/hooks/useActorBoundary';
import { FaqtoringApi } from '@infrastructure/faqtoring-api';
export function FaqtoringOnboardingReturn() {
    const { t } = useTranslation('faqtoring');
    const actor = useActorBoundary();
    const [params, setParams] = useSearchParams();
    const [returnState] = useState(() => params.get('state') || '');
    const [status, setStatus] = useState('loading');
    const completion = useRef();
    useEffect(() => {
        let active = true;
        // The single-use opaque state is not retained in browser history/storage.
        if (params.has('state'))
            setParams({}, { replace: true });
        if (!returnState || returnState.length > 200 || !actor.check()) {
            setStatus('error');
            return;
        }
        // One request even when React StrictMode replays the effect. A redirect alone never establishes readiness.
        if (!completion.current)
            completion.current = FaqtoringApi.onboardingReturn(returnState);
        completion.current.then(result => { if (active && actor.check())
            setStatus(result.status === 'ready' ? 'ready' : 'action_required'); }, () => { if (active && actor.check())
            setStatus('error'); });
        return () => { active = false; };
    }, [returnState, actor.check]);
    return _jsxs(Box, { sx: { maxWidth: 750, mx: 'auto', p: 3 }, children: [_jsx(Typography, { variant: 'h5', sx: { mb: 2 }, children: t('onboarding') }), actor.changed ? _jsx(Alert, { severity: 'warning', children: t('accountChanged') }) : status === 'loading' ? _jsx(Typography, { role: 'status', children: t('loading') }) :
                _jsx(Alert, { severity: status === 'ready' ? 'success' : status === 'error' ? 'error' : 'info', children: t(status === 'ready' ? 'accountVerified' : status === 'error' ? 'onboardingReturnError' : 'accountStillPending') }), _jsx(Button, { component: RouterLink, to: '/invoicing', sx: { mt: 2 }, children: t('backToInvoices') })] });
}
